import { useState, useEffect } from 'react';
import { AccessTime, MoreVert, TrendingUp, TrendingDown, Schedule } from '@mui/icons-material';

const UpcomingCard = () => {
  const [showMenu, setShowMenu] = useState(null);
  const [events, setEvents] = useState([]);
  const [stats, setStats] = useState({
    totalCustomers: 0,
    activeCustomers: 0,
    pendingTasks: 0
  });

  useEffect(() => {
    // Simulate fetching data from CSV
    // In a real app, this would come from the backend
    const mockEvents = [
      {
        id: 1,
        title: 'Portfolio Review - Khaled Al-Maani',
        time: '10:00 AM',
        type: 'meeting',
        priority: 'high',
        customerId: '101136'
      },
      {
        id: 2,
        title: 'Follow up - Nader Al-Masri',
        time: '2:00 PM',
        type: 'followup',
        priority: 'medium',
        customerId: '101982'
      },
      {
        id: 3,
        title: 'Investment Discussion - Mahmoud Al-Jundi',
        time: '4:00 PM',
        type: 'discussion',
        priority: 'high',
        customerId: '102874'
      },
      {
        id: 4,
        title: 'Credit Review - Amira Al-Kurdi',
        time: '11:00 AM',
        type: 'review',
        priority: 'medium',
        customerId: '103926'
      }
    ];

    setEvents(mockEvents);
    
    // Mock stats based on CSV data structure
    setStats({
      totalCustomers: 502,
      activeCustomers: 387,
      pendingTasks: 24
    });
  }, []);

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'border-l-[#B4E50D] bg-[#2A2A2A]';
      case 'medium':
        return 'border-l-[#B4E50D] bg-[#1A1A1A]';
      default:
        return 'border-l-[#808080] bg-[#1A1A1A]';
    }
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'meeting':
        return '🤝';
      case 'followup':
        return '📞';
      case 'discussion':
        return '💬';
      case 'review':
        return '📋';
      default:
        return '📅';
    }
  };

  return (
    <div className="bg-[#1A1A1A] rounded-xl p-6 shadow-xl border border-[#2A2A2A] hover:border-[#B4E50D] transition-all duration-300">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-[#FFFFFF]">Upcoming Tasks</h2>
        <div className="bg-[#B4E50D] p-3 rounded-xl">
          <Schedule className="text-[#0A0A0A]" />
        </div>
      </div>

      {/* Stats Overview */}
      <div className="grid grid-cols-3 gap-4 mb-6">
        <div className="text-center">
          <div className="text-2xl font-bold text-[#B4E50D]">{stats.totalCustomers}</div>
          <div className="text-xs text-[#B0B0B0]">Total Customers</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-[#B4E50D]">{stats.activeCustomers}</div>
          <div className="text-xs text-[#B0B0B0]">Active</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-[#B4E50D]">{stats.pendingTasks}</div>
          <div className="text-xs text-[#B0B0B0]">Pending</div>
        </div>
      </div>
      
      <div className="space-y-3 max-h-[300px] overflow-y-auto scrollbar-thin scrollbar-thumb-[#3A3A3A] scrollbar-track-[#2A2A2A] hover:scrollbar-thumb-[#B4E50D]">
        {events.map((event) => (
          <div 
            key={event.id} 
            className={`p-3 rounded-xl border-l-4 ${getPriorityColor(event.priority)} relative group hover:bg-[#2A2A2A] transition-all duration-200`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3 flex-1">
                <span className="text-lg">{getTypeIcon(event.type)}</span>
                <div className="flex-1">
                  <h3 className="font-medium text-[#FFFFFF] text-sm">{event.title}</h3>
                  <div className="flex items-center space-x-2 mt-1">
                    <AccessTime className="text-[#B0B0B0] text-xs" />
                    <p className="text-xs text-[#B0B0B0]">{event.time}</p>
                    <span className="text-xs px-2 py-1 rounded-full bg-[#2A2A2A] text-[#B0B0B0]">
                      {event.priority}
                    </span>
                  </div>
                </div>
              </div>
              <button 
                onClick={() => setShowMenu(showMenu === event.id ? null : event.id)}
                className="p-1 hover:bg-[#2A2A2A] rounded-lg text-[#B0B0B0] opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <MoreVert className="text-sm" />
              </button>
            </div>

            {showMenu === event.id && (
              <div className="absolute right-0 mt-2 w-48 bg-[#1A1A1A] rounded-xl shadow-2xl border border-[#2A2A2A] z-10">
                <div className="px-4 py-2 text-sm text-[#FFFFFF] hover:bg-[#2A2A2A] cursor-pointer transition-colors">
                  View Customer Details
                </div>
                <div className="px-4 py-2 text-sm text-[#FFFFFF] hover:bg-[#2A2A2A] cursor-pointer transition-colors">
                  Reschedule
                </div>
                <div className="px-4 py-2 text-sm text-[#B4E50D] hover:bg-[#2A2A2A] cursor-pointer transition-colors">
                  Mark Complete
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-4 pt-4 border-t border-[#2A2A2A]">
        <button className="w-full py-3 px-4 bg-[#B4E50D] text-[#0A0A0A] rounded-xl font-medium hover:shadow-lg transition-all duration-200 hover:transform hover:scale-105">
          View All Tasks
        </button>
      </div>
    </div>
  );
};

export default UpcomingCard;